<template>
  <section class="where">
    <form class="where__form" @submit.prevent="search">
      <label class="where__label" for="where-number">Где рейс?</label>
      <input
        id="where-number"
        v-model="number"
        class="where__input"
        inputmode="numeric"
        autocomplete="off"
        placeholder="Номер заявки из TMS, например 50754456"
      />
      <button class="where__btn" type="submit" :disabled="pending || !number.trim()">
        {{ pending ? 'Ищем…' : 'Найти' }}
      </button>
    </form>

    <p v-if="error" class="where__error">{{ error }}</p>

    <div v-if="answer" :class="['where__answer', answer.found ? 'is-found' : 'is-missing']">
      <div class="where__title">{{ answer.title }}</div>
      <ul class="where__reasons">
        <li v-for="(reason, i) in answer.reasons" :key="i">{{ reason }}</li>
      </ul>
      <p v-if="answer.next_step" class="where__next">{{ answer.next_step }}</p>
      <div class="where__actions">
        <router-link v-if="answer.found && answer.trip" class="where__link" :to="`/trips/${answer.trip.id}`">
          Открыть рейс
        </router-link>
        <button v-if="!answer.found" class="where__report" type="button" @click="$emit('report', answer.number)">
          Сообщить в IT
        </button>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'
import { whereIsTrip } from '@/backend/workspaceApi'

defineEmits(['report'])

const number = ref('')
const pending = ref(false)
const answer = ref(null)
const error = ref('')

async function search() {
  const value = number.value.trim()
  if (!value) return
  pending.value = true
  error.value = ''
  try {
    answer.value = await whereIsTrip(value)
  } catch (e) {
    answer.value = null
    error.value = e?.message || 'Не удалось проверить рейс'
  } finally {
    pending.value = false
  }
}
</script>

<style scoped>
.where { background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; padding: 14px 16px; }
.where__form { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; }
.where__label { font-weight: 700; color: #111827; }
.where__input {
  flex: 1 1 260px;
  min-width: 0;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 8px 12px;
  font: inherit;
}
.where__input:focus { outline: 2px solid #c7d2fe; border-color: #4f46e5; }
.where__btn, .where__report, .where__link {
  border: 0;
  border-radius: 8px;
  padding: 8px 16px;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
}
.where__btn, .where__link { background: #4f46e5; color: #fff; }
.where__btn:disabled { opacity: 0.5; cursor: default; }
.where__report { background: #fff; color: #b91c1c; border: 1px solid #fca5a5; }
.where__error { margin-top: 10px; color: #b91c1c; font-size: 0.875rem; }
.where__answer { margin-top: 12px; border-radius: 10px; padding: 12px 14px; }
.where__answer.is-found { background: #f0fdf4; border: 1px solid #bbf7d0; }
.where__answer.is-missing { background: #fffbeb; border: 1px solid #fde68a; }
.where__title { font-weight: 700; margin-bottom: 6px; color: #111827; }
.where__reasons { margin: 0 0 0 18px; display: grid; gap: 4px; font-size: 0.875rem; color: #374151; }
.where__next { margin-top: 8px; font-size: 0.85rem; color: #92400e; }
.where__actions { margin-top: 10px; display: flex; gap: 8px; }
</style>
